import { useNetworkStatus } from './networkStatus';

export function NetworkStatusBootstrap() {
  useNetworkStatus();
  return null;
}
